export default __webpack_public_path__ + "static/media/leh1.7e3a0f68.jpg";